function Resume() {
  return (
    <section id="resume" class="resume px-5">
      <div class="container px-5">
        <div class="section-title">
          <h2>Resume</h2>
          <p>
            Over <strong>2.0 years</strong> of strong experience as{" "}
            <strong>MERN Stack</strong> web developer with a solid understanding
            of front-end technologies, <strong>MVC frameworks</strong>, and{" "}
            <strong>Restful web services</strong>. Strong knowledge in MEN/MEAN
            Stack with vast experience in building Web Applications, used{" "}
            <strong>React /Angular</strong> for client-side,{" "}
            <strong>Node.js/Express</strong> for server-side and MongoDB, SQL
            Server for database.
          </p>
        </div>

        <div class="row">
          <div class="col-lg-6" data-aos="fade-up">
            <h3 class="resume-title">Sumary</h3>
            <div class="resume-item pb-0">
              <h4>DIPAM HALDER</h4>
              <p>
                <em>
                  Innovative and deadline-driven software engineers with two
                  months of experience.
                </em>
              </p>
              <ul>
                <li>Kolkata,IND</li>
                <li>+91 8001388527</li>
                <li>dipamhalder0@gmail.com</li>
              </ul>
            </div>

            <h3 class="resume-title">Education</h3>
            <div class="resume-item">
              <h4>BACHELOR OF ENGINEERING</h4>
              <h5>2017 - 2021</h5>
              <p>
                <em>University Institute of Technology, Burdwan,WB</em>
              </p>
              <p>
                <em>Information Technology</em>
              </p>
              <li>
                <b>CGPA:</b>8.65
              </li>
            </div>

            <div class="resume-item">
              <h4>
                12
                <sup>
                  <b>th</b>
                </sup>{" "}
                STANDARD
              </h4>
              <h5>2016 - 2017</h5>
              <p>
                <em>Gurap RK Institution</em>
              </p>
              <li>
                <b>Marks:</b>73.8%
              </li>
            </div>
            <div class="resume-item">
              <h4>
                10
                <sup>
                  <b>th</b>
                </sup>{" "}
                STANDARD
              </h4>
              <h5>2014 - 2015</h5>
              <p>
                <em>Gurap RK Institution</em>
              </p>
              <li>
                <b>Marks:</b>81%
              </li>
            </div>
          </div>
          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 class="resume-title">Professional Experience</h3>
            <div class="resume-item">
              <h4>Project SBSA</h4>
              <h5>2021 - Present</h5>
              
              <p><strong><em>TCS l  Gitanjali Park,Kolkata,West Bengal 700156</em></strong></p>
              <p>
                <li>
                  <b>Skills:- </b>Node JS, Sequelize, Express JS, JWT, React JS,
                  JS
                </li>
                <li>
                  <b>Roles:- </b>Software Developer(C1Y)
                </li>
                <li>
                  <b>Responsibility:- </b>This is the South Africa Standard Bank
                  Insurance Project. Here I have worked on user authentication
                  and authorization using JWT and worked on some rest APIs. Also
                  worked on Data migration.
                </li>
                <li>
                  <b>Tools used:- </b>VS Code, Microsoft SQL Server
                </li>
              </p>
              {/* <ul>
                <li>
                  Builed movie recommendation engine using Content-Base
                  algorithm.
                </li>
                <li>
                  Used Python,scikit-learn,numpy,pandas,annaconda3,jupiter.
                </li>
              </ul> */}
            </div>
            <div class="resume-item">
              <h4>Project TROKIAA</h4>
              <h5>8th March-1st Oct 2021 </h5>
              <p><strong><em>Think Future Technologies Pvt. Ltd </em></strong></p>

              <li>
                <b>Skills:- </b>Node JS, Sequelize, Express JS, JWT, React JS,
                JS
              </li>
              <li>
                <b>Roles:- </b>Software Engineer(L1)
              </li>
              <li>
                <b>Responsibility:- </b>Here I have built projects from scratch
                and I have expertise in using React.js/Redux to build User
                interfaces, strong knowledge of state store, middleware, action
                creator, reducer, and container. Extensive experience in
                developing Restful web services with Express and Node JS.
              </li>
              <li>
                <b>Tools used:- </b>VS Code, Mongo DB Compass
              </li>
              {/* <ul>
                <li>
                  Developed Gender-Classifier using DecisionTreeClassifier.{" "}
                </li>
                <li>
                  Used stremlit The fastest way to build and share data apps
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
